import BaseModelDistribution from "@/models/BaseModelDistribution.js";

export const GridConfig = {
	list: BaseModelDistribution.list,
	columns: BaseModelDistribution.columns,
	grid: {
		gridId: 'DistributionGrid',
		height: 500,
		checkbox: true,
		edit: true,
		delete: false,
		document: true,
		groupable: true,
	}
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			id: "btnAddDistribution",
			type: "button",
			text: "Add Distribution",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		},
		{
			id: "btnBulkImportDistribution",
			type: "button",
			text: "Bulk Import",
			showIcon: "toolbar",
			icon: "upload",
			attributes: {
				"class": "float-right-btn btn btn-secondary"
			},

		},

	]
}